import styled from 'styled-components'
import { Done, Error } from '@material-ui/icons'
import { IconProps } from '@material-ui/core/Icon'
import TextField, { TextFieldProps } from '@material-ui/core/TextField'
import { colors } from '../../styles'
import { ICustomTextFieldOrigin } from './CustomTextFieldOrigin'

export const StyledTextField = styled(TextField)`
  margin-bottom: 16px;
` as React.ComponentType<TextFieldProps & ICustomTextFieldOrigin>

export const StyledDone = styled(Done)`
  font-size: 20px;
` as unknown as React.ComponentType<IconProps>

export const StyledError = styled(Error)`
  color: ${colors.red};
  font-size: 20px;
` as unknown as React.ComponentType<IconProps>
